import React from 'react'
import { Mutation } from "react-apollo";
import BlackListsForm from "../components/form";
import { ADD_BLACK_LISTS, GET_BLACK_LIST } from "../../../queries/blackList";

const Add = (props) => {
  return (
    <Mutation
      mutation={ADD_BLACK_LISTS}
      update={(store, { data: { createBlackLists } }) => {
        const { blackList } = store.readQuery({ query: GET_BLACK_LIST });
        store.writeQuery({
          query: GET_BLACK_LIST,
          data: { blackList: blackList.concat([createBlackLists]) }
        });
      }}
      refetchQueries={[
        {query:GET_BLACK_LIST}
      ]}
      awaitRefetchQueries={true}
      >
        
      {createBlackLists => (
        <BlackListsForm query_f = {createBlackLists} {...props}/>
      )}
    </Mutation>
  );
};

export default Add;